import React, { ReactElement } from 'react'
import { BasketModel } from './types/models'
import DeliveryPriceDescription from './DeliveryPriceDescription'
import { formatNumberString, formatPriceString } from '../../common/helpers/number-formatters'

type BasketSummaryProps = {
  basket: BasketModel;
  includeVat: boolean;
  orderTotal: string;
  shippingAmount: string;
  shippingAmountIncVat: string;
  shippingQuoteNeeded: boolean;
  subtotal: string;
  subtotalIncVat: string;
  vatTotal: string;
  profit: string
}

const BasketSummary = ({
  basket, includeVat, orderTotal, shippingAmount, shippingAmountIncVat, shippingQuoteNeeded, subtotal, subtotalIncVat, vatTotal, profit
}: BasketSummaryProps): ReactElement => {
  const pluralize = (thing: string, quantity: number): string => {
    if (quantity === 1) {
      return thing
    }
    return `${thing}s`
  }

  return (
    <div className="basket-basketSummary">
      <h3 className="mobile-only">Summary</h3>
      <table className="basket-summary-table">
        <tbody>
          <tr className="summary-detail sub-total">
            <th className="price">{`Subtotal (${basket.total_quantity} ${pluralize('item', basket.total_quantity)})`}</th>
            <td className="price basket-total">{formatPriceString(includeVat ? subtotalIncVat : subtotal)}</td>
          </tr>
          <tr className="summary-detail delivery-cost">
            <th className="price">Delivery</th>
            <td className="price delivery">
              <DeliveryPriceDescription
                shippingAmount={includeVat ? shippingAmountIncVat : shippingAmount}
                shippingQuoteNeeded={shippingQuoteNeeded} />
            </td>
          </tr>
          <tr className="summary-detail total-weight">
            <th className="price">Weight</th>
            <td className="price">{ formatNumberString(basket.weight, 2) }&nbsp;kg</td>
          </tr>
          {
            includeVat
              ? <></>
              : <tr className="summary-detail vat-amount">
              <th className="price">VAT (20%)</th>
              <td className="price">{formatPriceString(vatTotal)}</td>
          </tr>
          }
          <tr id="orderGrandTotal" className="summary-detail order-total">
            <th className="price">Order Total</th>
            <td className="price">{formatPriceString(orderTotal)}</td>
          </tr>
          {
            (profit === undefined || profit === '')
              ? <></>
              : <tr className="summary-detail">
              <th className="price">Profit</th>
              <td className="price">{formatPriceString(profit)}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  )
}

export default BasketSummary
